import { Text, View } from "@react-pdf/renderer";
import PDFHorizontalTable from "components/PDF/Table/HorizontalTable";
import { BalancoFinanceiroPdfResponse } from "core/features/relatorios/typings";
import { useResumoBalancoFinanceiroTableRows } from "./hooks/useResumoBalancoFinanceiroTableRows";

interface ResumoBalancoFinanceiroProps {
  data: BalancoFinanceiroPdfResponse;
}

export default function ResumoBalancoFinanceiro({
  data,
}: ResumoBalancoFinanceiroProps) {
  const rows = useResumoBalancoFinanceiroTableRows();
  return (
    <View>
      <Text
        style={{
          textAlign: "center",
          fontSize: 10,
          fontWeight: "bold",
          marginVertical: 4,
        }}
      >
        RESUMO
      </Text>

      <View style={{ marginBottom: 2 }}>
        <PDFHorizontalTable
          data={data}
          totalRow={data.resultado}
          totalRowTitle="RESULTADO:"
          rows={rows}
        />
      </View>
    </View>
  );
}
